import { apiClient } from "../../../lib/apiClient";
import type { ApiResponse } from "../../../types/apiResponse";
import type { QuoteData } from "../types";

export const fetchQuotes = async (): Promise<ApiResponse<QuoteData[]>> => {
  return apiClient<ApiResponse<QuoteData[]>>('/v1/quotes', {
    method: "GET"
  });
};
